const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "";
export const analyticsConfigured = /^G-[A-Z0-9]+$/.test(measurementId);

type Gtag = (...args: unknown[]) => void;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: Gtag;
  }
}

let initialized = false;
let previousPage: string | undefined;

export function setAnalyticsDisabled(disabled: boolean) {
  if (!analyticsConfigured) return;
  (window as unknown as Record<string, unknown>)[`ga-disable-${measurementId}`] = disabled;
  if (initialized) {
    window.gtag?.("consent", "update", {
      analytics_storage: disabled ? "denied" : "granted",
    });
  }
}

function initializeAnalytics() {
  if (!analyticsConfigured || initialized) return;
  initialized = true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer?.push(arguments);
  };
  window.gtag("consent", "default", {
    analytics_storage: "denied",
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
  });
  window.gtag("consent", "update", { analytics_storage: "granted" });
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);
}

export function trackPageView(pageTitle: string) {
  if (!analyticsConfigured) return;
  initializeAnalytics();

  const pageLocation = window.location.href;
  window.gtag?.("event", "page_view", {
    page_title: pageTitle,
    page_location: pageLocation,
    ...(previousPage ? { page_referrer: previousPage } : {}),
  });
  previousPage = pageLocation;
}
